import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './style1.css';

interface DeleteDemoProps {
    username: string | null;
    onLogout?: () => void;
}

const navLinks = [
    { name: 'HOME', href: '/' },
    { name: 'PROGRAMS', href: '/programs' },
    { name: 'VIDEOS', href: '/videos' },
    { name: 'IMAGES', href: '/images' },
    { name: 'DEMOS', href: '/demos' },
    { name: 'CERTIFICATES', href: '/certificates' },
    { name: 'ABOUT', href: '/about' },
];

const DeleteDemo: React.FC<DeleteDemoProps> = ({ username, onLogout }) => {
    const [demoId, setDemoId] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [confirmAll, setConfirmAll] = useState(false);

    // Only admin can access
    if (username !== 'admin') {
        return <div style={{ textAlign: 'center', marginTop: '2rem' }}>Access denied.</div>;
    }

    const handleDeleteDemo = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        if (!demoId) {
            setError('Demo ID is required.');
            return;
        }
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`/deletedemo/${demoId}`, {
                method: 'DELETE',
                headers: token ? { 'Authorization': `Bearer ${token}` } : {}
            });
            if (response.ok) {
                setSuccess('Demo deleted!');
                setDemoId('');
            } else {
                const data = await response.json();
                setError(data.message || 'Failed to delete demo.');
            }
        } catch (err) {
            setError('Network error.');
        }
    };

    const handleDeleteAllDemos = async () => {
        setError('');
        setSuccess('');
        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/deletealldemos', {
                method: 'DELETE',
                headers: token ? { 'Authorization': `Bearer ${token}` } : {}
            });
            if (response.ok) {
                setSuccess('All demos deleted!');
            } else {
                const data = await response.json();
                setError(data.message || 'Failed to delete all demos.');
            }
        } catch (err) {
            setError('Network error.');
        }
        setConfirmAll(false);
    };

    return (
        <div className="modern-layout" style={{ position: 'relative' }}>
            <header className="modern-header">
                <div className="header-container">
                    <nav className="modern-nav">
                        {navLinks.map(link =>
                            link.href.startsWith('/')
                                ? <Link
                                    key={link.name}
                                    to={link.href}
                                    className="modern-nav-link"
                                    style={{ textDecoration: 'none' }}
                                  >
                                    {link.name}
                                  </Link>
                                : <a
                                    key={link.name}
                                    href={link.href}
                                    className="modern-nav-link"
                                  >
                                    {link.name}
                                  </a>
                        )}
                        {onLogout && (
                            <button className="logout-btn" onClick={onLogout}>LOG OUT</button>
                        )}
                    </nav>
                </div>
            </header>
            <main className="modern-content">
                <div
                    style={{
                        maxWidth: 400,
                        margin: '2rem auto',
                        background: '#fff',
                        borderRadius: 12,
                        boxShadow: '0 2px 16px #6a11cb22',
                        padding: '2rem'
                    }}
                >
                    <h2 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>Delete Demo</h2>
                    <form onSubmit={handleDeleteDemo}>
                        <div style={{ marginBottom: '1rem' }}>
                            <label>Demo ID:</label>
                            <input
                                type="text"
                                value={demoId}
                                onChange={e => setDemoId(e.target.value)}
                                style={{ width: '100%', padding: '0.5rem', marginTop: 4 }}
                            />
                        </div>
                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '0.75rem',
                                background: 'linear-gradient(135deg, #cb116a 0%, #fc2525 100%)',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 6,
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                marginBottom: '1rem'
                            }}
                        >
                            Delete Demo
                        </button>
                    </form>
                    <hr style={{ margin: '2rem 0' }} />
                    <button
                        onClick={() => setConfirmAll(true)}
                        style={{
                            width: '100%',
                            padding: '0.75rem',
                            background: 'linear-gradient(135deg, #cb116a 0%, #fc2525 100%)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 6,
                            fontWeight: 'bold',
                            cursor: 'pointer'
                        }}
                    >
                        Delete All Demos
                    </button>
                    {confirmAll && (
                        <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                            <div style={{ color: 'red', marginBottom: '1rem' }}>
                                Are you sure you want to delete <b>ALL</b> demos? This cannot be undone!
                            </div>
                            <button
                                onClick={handleDeleteAllDemos}
                                style={{
                                    padding: '0.5rem 1.5rem',
                                    background: '#d32f2f',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 6,
                                    fontWeight: 'bold',
                                    marginRight: '1rem',
                                    cursor: 'pointer'
                                }}
                            >
                                Yes, Delete All
                            </button>
                            <button
                                onClick={() => setConfirmAll(false)}
                                style={{
                                    padding: '0.5rem 1.5rem',
                                    background: '#888',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 6,
                                    fontWeight: 'bold',
                                    cursor: 'pointer'
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                    {error && <div style={{ color: 'red', marginTop: '1rem' }}>{error}</div>}
                    {success && <div style={{ color: 'green', marginTop: '1rem' }}>{success}</div>}
                </div>
            </main>
            <footer className="modern-footer">
                &copy; {new Date().getFullYear()} Timo
            </footer>
        </div>
    );
};

export default DeleteDemo;